export class Breakpoint {
  public xs = false
  public sm = false
  public md = false
  public lg = false
  public xl = false
}
